import React, {useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import FilterDropdown, {FilterDropdownRef} from '../../../gallery/components/filters/FilterDropdown';
import FilterLayout from '../../../gallery/components/filters/FilterLayout';
import FilterRadioGroup, {RadioOption} from '../../../gallery/components/filters/FilterRadioGroup';
import {HierarchyType} from '../../../admin/artisticobjects/types/OrganizationalUnit';

interface HierarchyTypeFilterProps {
  hierarchyType: string;
  onFilterChange: (hierarchyType: string) => void;
}

const HierarchyTypeFilter: React.FC<HierarchyTypeFilterProps> = ({
  hierarchyType,
  onFilterChange
}) => {
  const {t} = useTranslation();
  const [tempHierarchyType, setTempHierarchyType] = useState<string>(hierarchyType);
  const filterDropdownRef = useRef<FilterDropdownRef>(null);

  const hierarchyOptions: RadioOption[] = [
    {label: t('gallery.filters.church'), value: HierarchyType.CHURCH},
    {label: t('gallery.filters.administrative'), value: HierarchyType.ADMINISTRATIVE}
  ];

  const hasActiveFilter = false;

  const applyFilter = () => {
    onFilterChange(tempHierarchyType);
  };

  const clearFilter = () => {
    setTempHierarchyType(HierarchyType.CHURCH);
    onFilterChange(HierarchyType.CHURCH);
    closeDropdown();
  };

  const closeDropdown = () => {
    filterDropdownRef.current?.close();
  };

  const handleApplyClick = () => {
    applyFilter();
    closeDropdown();
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      applyFilter();
      closeDropdown();
    } else if (event.key === 'Escape') {
      setTempHierarchyType(hierarchyType);
      closeDropdown();
    }
  };

  const getDisplayLabel = () => {
    return hierarchyType === HierarchyType.CHURCH
      ? t('gallery.filters.churchHierarchy')
      : t('gallery.filters.administrativeHierarchy');
  };

  return (
    <FilterDropdown
      ref={filterDropdownRef}
      label={getDisplayLabel()}
      hasActiveFilter={hasActiveFilter}
      onClearFilter={clearFilter}
    >
      <FilterLayout
        title={t('gallery.filters.hierarchyType')}
        onClear={clearFilter}
        onApply={handleApplyClick}
      >
        <FilterRadioGroup
          value={tempHierarchyType}
          options={hierarchyOptions}
          onChange={setTempHierarchyType}
          name="hierarchyType"
          className="px-4"
        />
      </FilterLayout>
    </FilterDropdown>
  );
};

export default HierarchyTypeFilter;

